/**
 * N static frames of REAL components cross-faded in turn over one cycle —
 * frame i is visible for its slice of the loop. Lets a chapter show the
 * actual Live card walking through its states without a stage clock. The
 * frames share one grid cell, so the stack is as tall as its tallest frame
 * and a later, longer frame is never clipped.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC, ReactNode } from 'react';

export const FrameStack: FC<{
  frames: ReactNode[];
  cycleSeconds: number;
  className?: string;
}> = ({ frames, cycleSeconds, className }) => (
  <div className={`grid ${className ?? ''}`}>
    {frames.map((frame, i) => (
      <div
        key={i}
        className={`[grid-area:1/1] animate-dg-tut-frame opacity-0 motion-reduce:animate-none ${
          i === frames.length - 1 ? 'motion-reduce:opacity-100' : 'motion-reduce:hidden'
        }`}
        style={{
          animationDelay: `${((i * cycleSeconds) / frames.length).toFixed(2)}s`,
          animationDuration: `${cycleSeconds}s`,
        }}
        data-frame={i}
      >
        {frame}
      </div>
    ))}
  </div>
);
